<template>
  <button
    type="button"
    class="accessibility-button c-dark-grey"
    data-test="accessibility-button"
    @click="toggleAdaMode"
  >
    {{ isA11y ? config.decrease : config.increase }}
  </button>
</template>

<script>
const componentName = 'AccessibilityButton'

export default {
  name: componentName,
  props: {
    config: Object,
  },
  data() {
    return {
      isA11y: IB.a11y.isAdaActivated(),
    }
  },
  mounted() {
    this.isA11y = IB.a11y.isAdaActivated() && !IB.is_in_microsite
  },
  methods: {
    toggleAdaMode() {
      // execute AFTER the click event on '.accessibility-button' defined in accessibility.js
      setTimeout(() => {
        IB.a11y.onAdaButtonClick()
        this.isA11y = IB.a11y.isAdaActivated()
      }, 0)
    },
  },
}
</script>
